import React, { useEffect } from 'react';
import Modal from 'react-modal';
import './CSVPopup.scss';

Modal.setAppElement('#root')

const customStyle = {
    overlay: {
        backgroundColor: 'transparent'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: 'none',
        borderRadius: '10px',
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.5)'
    },
}

function SavingPopup({ isOpen, isCompleted, onClose }) {
    useEffect(() => {
        if (isCompleted && isOpen) {
            const timer = setTimeout(() => {
                if (onClose) {
                    onClose();
                }
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [isCompleted, isOpen, onClose]);

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            style={customStyle}
            shouldCloseOnOverlayClick={isCompleted}
            shouldCloseOnEsc={isCompleted}
            onRequestClose={handleClose}
        >
            <div className='sumDataModal savingPopup'>
                <div className='msg'>
                    <p>{isCompleted ? '파일 다운로드가 완료되었습니다' : '저장중입니다. 잠시만 기다려주세요.'}</p>
                </div>
                {isCompleted && (
                    <div className='btnsArea'>
                        <button onClick={handleClose}>확인</button>
                    </div>
                )}
            </div>
        </Modal>
    )
}

export default SavingPopup;
